import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

import { CreationTypeSelection } from './creationTypeSelection';

export function CreateReportButton({
  handleCreateFromScratch,
  handleShowTemplates,
}: {
  handleCreateFromScratch: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleShowTemplates: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack
      key="create-report"
      alignItems="center"
      direction="row"
      height="100%"
      justifyContent="flex-end"
    >
      <Button aria-describedby={'create-report'} onClick={handleClick} variant="contained">
        New Report
      </Button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        id={'create-report'}
        onClose={handleClose}
        open={open}
        sx={{ mt: 4, p: 2 }}
      >
        <CreationTypeSelection
          handleCreateFromScratch={handleCreateFromScratch}
          handleShowTemplates={handleShowTemplates}
          sx={{ p: 2, width: 360 }}
        />
      </Popover>
    </Stack>
  );
}
